import { ActivationGender } from '@/enums';

export const displayGender = (genders: number[]): string => {
  if (!Array.isArray(genders) || genders.length === 0) return 'Unknown';
  if (genders.length > 1) return 'Both';

  const gender = genders[0];
  switch (gender) {
    case ActivationGender.male:
      return 'Male';
    case ActivationGender.female:
      return 'Female';
    default:
      return 'Unknown';
  }
};

export const mapGender = (gender: string): Array<number> => {
  if (gender === 'both') {
    return [0, 1];
  } else if (gender === 'male') {
    return [0];
  } else if (gender === 'female') {
    return [1];
  }
  return [];
};
